import { Stack } from "@mui/material";

import { BodyTextM, cs, HeadingS } from "@repo/ui";
import { type FC } from "react";
import { AMLRedirect } from "../../../components/AML";
import { BankIDAmlButton } from "../../../components/AML/identification";
import { Seo } from "../../../components/SEO";
import withProtection from "../../../highOrderComponents/withProtection";

export const Title = "Identifikace";

const AML: FC = () => {
	return (
		<Stack gap={4}>
			<HeadingS marginBottom={0}>{cs.AML.amlReasoning.greeting}</HeadingS>
			<BodyTextM>{cs.AML.amlReasoning.insurancePayout}</BodyTextM>
			<BankIDAmlButton actionInfo={{ redirect: AMLRedirect.Profile }} />
		</Stack>
	);
};

export const Head: FC = () => (
	<Seo title={Title}>
		<meta name="robots" content="noindex" />
	</Seo>
);

export default withProtection(AML);
